import { BrandName } from "@/types/branding";
import settldLogo from "@/assets/logo-dark.png";
import notifyNowLogo from "@/assets/notify_now/NotifyNOW_2C_Logo.png";
import { NOTIFY_NOW_CONTACT_INFO, SettldContactInfo } from "@/utils/Constants";

export const detectBrandNameFromUrl = (): BrandName => {
  // const currentUrl = window.location.href.toLowerCase();
  // return currentUrl.includes(BrandName.NOTIFY_NOW.toLowerCase())
  //   ? BrandName.NOTIFY_NOW
  //   : BrandName.SETTLD;
  return BrandName.SETTLD;
};

export const getBrandLogo = (brandName: BrandName): string => {
  switch (brandName) {
    case BrandName.NOTIFY_NOW:
      return notifyNowLogo;
    case BrandName.SETTLD:
      return settldLogo;
    default:
      return settldLogo; // Fallback to Settld logo
  }
};

export const getBrandContactUrl = (
  brandName: BrandName
): SettldContactInfo.ContactUs | NOTIFY_NOW_CONTACT_INFO.ContactUs => {
  return {
    [BrandName.SETTLD]: SettldContactInfo,
    [BrandName.NOTIFY_NOW]: NOTIFY_NOW_CONTACT_INFO,
  }[brandName].ContactUs;
};
export const getBrandEmail = (
  brandName: BrandName
): SettldContactInfo.Email | NOTIFY_NOW_CONTACT_INFO.Email => {
  return {
    [BrandName.SETTLD]: SettldContactInfo,
    [BrandName.NOTIFY_NOW]: NOTIFY_NOW_CONTACT_INFO,
  }[brandName].Email;
};

export const getBrandTelephone = (
  brandName: BrandName
): SettldContactInfo.Telephone | NOTIFY_NOW_CONTACT_INFO.Telephone => {
  return {
    [BrandName.SETTLD]: SettldContactInfo,
    [BrandName.NOTIFY_NOW]: NOTIFY_NOW_CONTACT_INFO,
  }[brandName].Telephone;
};

export function x_by_brand(brandName: BrandName): number {
  return {
    [BrandName.SETTLD]: 90,
    [BrandName.NOTIFY_NOW]: 138.24,
  }[brandName];
}
export function getBrandTermsAndConditionsUrl(
  brandName: BrandName
): SettldContactInfo.TermsAndConditionsUrl | NOTIFY_NOW_CONTACT_INFO.TermsAndConditionsUrl {
  return {
    [BrandName.SETTLD]: SettldContactInfo,
    [BrandName.NOTIFY_NOW]: NOTIFY_NOW_CONTACT_INFO,
  }[brandName].TermsAndConditionsUrl;
}

export function getBrandPrivacyPolicyUrl(
  brandName: BrandName
): SettldContactInfo.PrivacyPolicyUrl | NOTIFY_NOW_CONTACT_INFO.PrivacyPolicyUrl {
  return {
    [BrandName.SETTLD]: SettldContactInfo,
    [BrandName.NOTIFY_NOW]: NOTIFY_NOW_CONTACT_INFO,
  }[brandName].PrivacyPolicyUrl;
}
// reviewUrl: SettldContactInfo.ReviewUrl,
// trustPilotUrl: SettldContactInfo.TrustPilotUrl,
// contributionUrl: SettldContactInfo.ContributionUrl,
// coreWebsiteUrl: SettldContactInfo.CoreWebsiteUrl,
export function getBrandReviewUrl(
  brandName: BrandName
): SettldContactInfo.ReviewUrl | NOTIFY_NOW_CONTACT_INFO.ReviewUrl {
  return {
    [BrandName.SETTLD]: SettldContactInfo,
    [BrandName.NOTIFY_NOW]: NOTIFY_NOW_CONTACT_INFO,
  }[brandName].ReviewUrl;
}
export function getBrandTrustPilotUrl(
  brandName: BrandName
): SettldContactInfo.TrustPilotUrl | NOTIFY_NOW_CONTACT_INFO.TrustPilotUrl {
  return {
    [BrandName.SETTLD]: SettldContactInfo,
    [BrandName.NOTIFY_NOW]: NOTIFY_NOW_CONTACT_INFO,
  }[brandName].TrustPilotUrl;
}
export function getBrandContributionUrl(
  brandName: BrandName
): SettldContactInfo.ContributionUrl | NOTIFY_NOW_CONTACT_INFO.ContributionUrl {
  return {
    [BrandName.SETTLD]: SettldContactInfo,
    [BrandName.NOTIFY_NOW]: NOTIFY_NOW_CONTACT_INFO,
  }[brandName].ContributionUrl;
}
export function getBrandCoreWebsiteUrl(
  brandName: BrandName
): SettldContactInfo.CoreWebsiteUrl | NOTIFY_NOW_CONTACT_INFO.CoreWebsiteUrl {
  return {
    [BrandName.SETTLD]: SettldContactInfo,
    [BrandName.NOTIFY_NOW]: NOTIFY_NOW_CONTACT_INFO,
  }[brandName].CoreWebsiteUrl;
}
export const getBrandFavicon = (brandName: BrandName): string => {
  return brandName === BrandName.NOTIFY_NOW
    ? "/notify_now/Notifynow_Favicon.png"
    : "/icons/icon-192.png";
};

export const getIntestacyRulesUrl = (
  brandName: BrandName
): SettldContactInfo.IntestacyRulesUrl | NOTIFY_NOW_CONTACT_INFO.IntestacyRulesUrl => {
  return {
    [BrandName.SETTLD]: SettldContactInfo,
    [BrandName.NOTIFY_NOW]: NOTIFY_NOW_CONTACT_INFO,
  }[brandName].IntestacyRulesUrl;
};

export const getCookiesPolicyUrl = (
  brandName: BrandName
): SettldContactInfo.CookiePolicyUrl | NOTIFY_NOW_CONTACT_INFO.CookiePolicyUrl => {
  return {
    [BrandName.SETTLD]: SettldContactInfo,
    [BrandName.NOTIFY_NOW]: NOTIFY_NOW_CONTACT_INFO,
  }[brandName].CookiePolicyUrl;
};

export const getBrandWhatsApp = (
  brandName: BrandName
): SettldContactInfo.WhatsApp | NOTIFY_NOW_CONTACT_INFO.WhatsApp => {
  return {
    [BrandName.SETTLD]: SettldContactInfo,
    [BrandName.NOTIFY_NOW]: NOTIFY_NOW_CONTACT_INFO,
  }[brandName].WhatsApp;
};
